interface Props {
  html: string | null | undefined;
  subject?: string | null;
}

export function EmailPreview({ html, subject }: Props) {
  if (!html) {
    return <p style={{ color: '#999', fontStyle: 'italic' }}>No email preview available.</p>;
  }

  return (
    <div>
      {subject && (
        <div style={{ background: '#f9f9f9', border: '1px solid #eee', borderRadius: 4, padding: '8px 14px', marginBottom: 12 }}>
          <span style={{ fontSize: 11, color: '#999' }}>Subject: </span>
          <strong style={{ fontSize: 14 }}>{subject}</strong>
        </div>
      )}
      <div style={{ border: '1px solid #eee', borderRadius: 4, overflow: 'hidden' }}>
        <iframe
          srcDoc={html}
          style={{ width: '100%', height: 700, border: 'none' }}
          title="Email preview"
          sandbox="allow-same-origin"
        />
      </div>
    </div>
  );
}
